import { map, catchError } from 'rxjs/operators';
import { DigitalResourceVm, OhiUnitVm, ResourceCategoryVm, ResourceTypeVm, DigitalResourceShortVm } from './../../_models/digitalReource';
import { SelectValue } from './../../_models/selectValue';
import { ApiService } from './../../_services/api.service';
import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { AlertService } from '@app/_services/alert.service';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['../ohi-university.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResourcesComponent implements OnInit {
  @ViewChild("fileUpload", { static: false }) fileUpload: ElementRef; 

  files = [];
  maxFileUploadSize = 1 * 1024 * 1024 * 1024; //1 Gb limit
  gridData: any;
  originalItem: DigitalResourceShortVm;
  activeResource: DigitalResourceVm = new DigitalResourceVm();

  saving: boolean = false;
  submitted: boolean = false;
  uploading: boolean = false;
  selectableSettings: SelectableSettings;
  imageList: SelectValue[];

  ohiUnits: OhiUnitVm[]; 
  resourceCategories: ResourceCategoryVm[];
  resourceTypes: ResourceTypeVm[];

  constructor(
    private apiService: ApiService,
    private allertService: AlertService) {
    this.selectableSettings = {
      checkboxOnly: false,
      mode: 'single'
    };
  }

  ngOnInit(): void {
    this.apiService.getDigitalResourcesLookups().subscribe((responce) => {
      this.ohiUnits = responce.units;
      this.resourceCategories = responce.categories;
      this.resourceTypes = responce.types;
    });

    this.loadResources();
  }


  loadResources() {
    this.apiService.getDigitalResourceList().subscribe((data) => {
      this.gridData = data;
    });
  }

  getHasErrors() {
    return !this.activeResource ||
      !this.activeResource.title ||
      !this.activeResource.link ||
      !this.activeResource.resourceTypeId ||
      !this.activeResource.unitId ||
      !this.activeResource.categoryId;
  }

  cellClickHandler({ sender, rowIndex, columnIndex, dataItem, isEdited }) {
    this.originalItem = dataItem;
    this.apiService.getDigitalResource(dataItem.id).subscribe((item) => {
      this.activeResource = item;
    });
  }

  uploadFile(file) {
    this.allertService.clear();
    if (!this.activeResource.unitId) {
      return;
    }
    setTimeout(() => { this.uploading = true }) ;
    const formData = new FormData();
    formData.append('file', file.data, file.data.name);
    file.inProgress = true;
    let unit = this.ohiUnits.filter((u) => { return u.id === this.activeResource.unitId; })[0];
    this.apiService.uploadDigitalResource(formData, unit.title.toLowerCase())
    .pipe(
        map(event => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              file.progress = Math.round(event.loaded * 100 / event.total);
              break;
            case HttpEventType.Response:
              return event;
          }
        }),
        catchError((error: HttpErrorResponse) => {
          this.uploading = false;
          file.inProgress = false;
          console.log(`An error occured while uploding resoirce: ${error}`);
          return (`${file.data.name} upload failed.`);
        })
      )
      .subscribe((event: any) => {
        this.uploading = false;
        if (typeof (event) === 'object') {
          console.log(event.body);
          if (event.body.code == 200) {
            this.activeResource.link = event.body.uri;
          }          
        }
      });
  }

  private uploadFiles() {
    this.fileUpload.nativeElement.value = '';
    this.files.forEach(file => {
      this.uploadFile(file);
    });
  }

  onClick() {
    const fileUpload = this.fileUpload.nativeElement; 
    fileUpload.onchange = () => {
      if (fileUpload.files[0].size > this.maxFileUploadSize) {
        fileUpload.value = '';
        this.allertService.error('File size is too big');
        return;
      }
      this.files.push({ data: fileUpload.files[0], inProgress: false, progress: 0 });
      this.uploadFiles();
    };
    fileUpload.click();
  }

  

  addResource() {
    this.submitted = true;
    setTimeout(() => {
      this.submitted = false;
      this.activeResource = new DigitalResourceVm();
    }, 0);
  }

  saveResource() {
    this.saving = true;
    const isNew = !this.activeResource.id;
    this.apiService.saveDigitalResource(this.activeResource).subscribe((response) => {
      if (response.code === 200) {        
        this.loadResources();
      }      
      this.saving = false;
    })
  }
}
